import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useOrganizationManagement } from "@/hooks/use-organization-management";
import { ManageWorkspaceHeader } from "@/components/workspace/ManageWorkspaceHeader";
import { ManageWorkspaceContent } from "@/components/workspace/ManageWorkspaceContent";

export default function ManageWorkspaces() {
  const { t } = useTranslation();
  const {
    organizations,
    isLoading,
    fetchOrganizations,
    handleRename,
    handleDelete,
  } = useOrganizationManagement();

  useEffect(() => {
    fetchOrganizations();
  }, []);

  if (isLoading) {
    return <div className="p-6">{t('Loading...')}</div>;
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <ManageWorkspaceHeader onWorkspaceCreated={fetchOrganizations} />
      <ManageWorkspaceContent
        organizations={organizations}
        onRename={handleRename}
        onDelete={handleDelete}
      />
    </div>
  );
}